document.addEventListener("DOMContentLoaded", function () {
  const messageWrapper = document.querySelector(".index-message-wrapper");
  const SESSION_HIDE_KEY = "indexMessageHidden";
  // How long after the last scroll event to wait before fading the banner back in.
  const SCROLL_IDLE_MS = 200;
  // Delay before the banner returns at the top, matching the nav logo. The logo's
  // _onScrolledToTop runs setTimeout(showLogo, 300) — so 300ms after the SAME
  // HeaderState.atTop transition we subscribe to below, then a 0.3s CSS fade.
  // Driving both off that one signal is what makes the timing identical.
  const TOP_REVEAL_DELAY_MS = 300;

  function hasMessageContent() {
    const englishContent = messageWrapper.querySelector(
      ".index-message-english"
    );
    const japaneseContent = messageWrapper.querySelector(
      ".index-message-japanese"
    );
    const hasEnglish =
      englishContent && englishContent.textContent.trim().length > 0;
    const hasJapanese =
      japaneseContent && japaneseContent.textContent.trim().length > 0;
    return hasEnglish || hasJapanese;
  }

  // Dismissed earlier this session → stay hidden.
  if (sessionStorage.getItem(SESSION_HIDE_KEY) === "1") {
    if (messageWrapper) messageWrapper.style.display = "none";
    return;
  }

  if (!messageWrapper || !hasMessageContent()) {
    if (messageWrapper) messageWrapper.style.display = "none";
    return;
  }

  // The banner is a fixed band pinned directly under the nav (positioning lives
  // in style-index.css: .index-message-wrapper.is-fixed). It persists across the
  // whole site — index, collection, product, and over the collection/PDP modals —
  // until the user dismisses it.
  messageWrapper.classList.add("is-fixed");

  // Mark the banner as open so the PDP nav background band shows (and later fades
  // out in sync on dismiss) — see #nav-bg in style-index.css.
  document.body.classList.add("banner-open");

  // Fade the banner out while scrolling and back in on EITHER of two triggers:
  //  • the user returns to the top — fades in IN LOCKSTEP with the nav logo;
  //  • the user stops scrolling mid-page — returns after SCROLL_IDLE_MS.
  // Driven by body.banner-scrolling (see style-index.css) so the PDP nav band
  // fades in lockstep. Stops once the banner is dismissed.
  let dismissed = false;
  let scrollIdleTimer;
  let topRevealTimer = null;
  function reveal() {
    document.body.classList.remove("banner-scrolling");
  }
  function hide() {
    document.body.classList.add("banner-scrolling");
  }

  // The nav logo's return is governed by HeaderState.atTop: its scroll sentinel
  // (35px) flips that flag, and _onScrolledToTop then waits 300ms before the
  // logo's 0.3s fade. We subscribe to the SAME flag so the banner's reveal fires
  // off the identical instant + delay — no re-deriving it from raw scrollY, which
  // is what kept landing early/late. Only wired on the index page, where the
  // sentinel actually mutates atTop (HeaderState exists everywhere as a stub).
  const isIndex = document.body.classList.contains("template-index");
  const headerState = window.HeaderState;
  const logoSynced =
    isIndex && headerState && typeof headerState.subscribe === "function";

  if (logoSynced) {
    headerState.subscribe(function (state, prev) {
      if (dismissed || state.atTop === prev.atTop) return;
      if (state.atTop) {
        // Back at the top: reveal on the logo's 300ms delay (+ 0.3s CSS fade).
        clearTimeout(scrollIdleTimer);
        clearTimeout(topRevealTimer);
        topRevealTimer = setTimeout(function () {
          topRevealTimer = null;
          reveal();
        }, TOP_REVEAL_DELAY_MS);
      } else {
        // Left the top: hide with the bar, cancel any pending reveal.
        clearTimeout(topRevealTimer);
        topRevealTimer = null;
        hide();
      }
    });
  }

  window.addEventListener(
    "scroll",
    function () {
      if (dismissed) return;
      // At the top on the index, the subscription owns the banner (mirroring the
      // logo, which stays put / returns on its timer). Don't hide on micro-scroll
      // and don't let the idle timer pop it in ahead of the logo.
      if (logoSynced && headerState.state.atTop) {
        clearTimeout(scrollIdleTimer);
        return;
      }
      hide();
      clearTimeout(scrollIdleTimer);
      scrollIdleTimer = setTimeout(reveal, SCROLL_IDLE_MS);
    },
    { passive: true }
  );

  // Click anywhere on the banner to dismiss it (this session only). The nav band
  // fades out together with it because the class is dropped at the start of the fade.
  messageWrapper.addEventListener("click", function () {
    dismissed = true;
    clearTimeout(scrollIdleTimer);
    clearTimeout(topRevealTimer);
    document.body.classList.remove("banner-scrolling");
    messageWrapper.style.opacity = "0";
    document.body.classList.remove("banner-open");
    const onTransitionEnd = function (e) {
      if (e.propertyName === "opacity") {
        messageWrapper.style.display = "none";
        sessionStorage.setItem(SESSION_HIDE_KEY, "1");
        messageWrapper.removeEventListener("transitionend", onTransitionEnd);
      }
    };
    messageWrapper.addEventListener("transitionend", onTransitionEnd);
  });
});
